import { atom } from 'jotai';

export const residenceFlagAtom = atom(false);
